module.exports = __webpack_public_path__ + "03_bob_grey.36be61c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_bob_grey.png
// module id = dEER
// module chunks = 0